/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import { Line } from '@ant-design/plots';

const CustomLineChart = (props: any) => {
	const [lineChartData, setlineChartData] = useState<any[]>([]);


	useEffect(() => {
		let originalData: any[] = props?.data;

		let originalData2: any[] = originalData.map((element: any) => {
			element.value = parseFloat(element?.value);
			// element.type = "Holtokuluihin (12 kk rullaava ka) suhteutettu maksukyvykkyys"

			return element;
		})
		setlineChartData(originalData2)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

	let averageCount = 0;
	const config: any = {
		data: lineChartData,
		xField: 'yearMonth',
		yField: 'value',
		seriesField: 'type',
		xAxis: {
			nice: true,
			// title: {
			// 	style: {
			// 		fontSize: 16,
			// 	},
			// },
			// line: {
			// 	style: {
			// 		stroke: '#fff',
			// 	},
			// },
			// tickLine: {
			// 	style: {
			// 		lineWidth: 2,
			// 		stroke: '#aaa',
			// 	},
			// 	length: 5,
			// },
			// grid: {
			// 	line: {
			// 		style: {
			// 			stroke: '#ddd',
			// 			lineDash: [4, 2],
			// 		},
			// 	},
			// 	alternateColor: 'rgba(0,0,0,0.05)',
			// },
		},
		yAxis: {
			// grid: {
			//   line: true
			// },
			// tickCount: 6,
			// min: 2,
			// max:-10
		},
		style: {
			color: "#fff"
		},
		color: ['#81ffb8', '#00bcd4'],
		point: {
			size:2,
			shape: (type:any)=>{
				
				return type.type=='Keskiarvo'?'square':'dot'
			},
			style: {
				lineWidth: 3,
			},
		},
		label: {
			layout: [
			  {
				type: 'hide-overlap',
			  },
			],
			formatter: (item:any,index:any) => {
				if(item.type == "Keskiarvo" && averageCount==0){
					averageCount++;
					return item.value?.toFixed(1)?.replace(".",",");
				}else if(item.type == "Keskiarvo"){
					return "";
				}else{
					return item.value?.toFixed(1)?.replace(".",",");
				}
			},
		},
		legend: {
			position: 'top-left',
		},
		tooltip: {
			showMarkers: false,
			formatter: (item:any,index:any) => {
				return { name: item.type, value: item.value?.toFixed(1)?.replace(".",",")};
			},
		},
		state: {
			active: {
				style: {
					shadowBlur: 4,
					// stroke: '#000',
					// fill: 'red',
				},
			},
		},
		interactions: [
			{
				type: 'marker-active',
			},
		],
		autofit: "height",
		theme: {
			"components": {
				"axis": {
					"common": {
						"label": {
							"style": {
								"fill": "#000",
								"fontSize": 7,
								// "lineHeight": 12,
								// "fontFamily": "\"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,\n    \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    \"Noto Color Emoji\""
								"fontWeight":"600",
							}
						},
					},
				},
				"legend": {
					"common": {
						"itemName": {
							"spacing": 5,
							"style": {
								"fill": "#000",
								// "fontFamily": "\"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,\n    \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    \"Noto Color Emoji\"",
								"fontSize": 10,
								// "lineHeight": 12,
								"fontWeight": props?.showbtn && props?.showbtn === "0" ? "400" : "600",
								// "textAlign": "start",
								// "textBaseline": "middle"
							}
						},
						"maxItemWidth": 500,
					},
				},
			},
			"labels": {
				"offset": 20,
				"style": {
					"fill": "#000",
					"fontSize": 10,
					"fontFamily": "\"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,\n    \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\",\n    \"Noto Color Emoji\"",
					"stroke": null,
					"lineWidth": 0
				},
				// "fillColorLight": "#ffffff",
				// "autoRotate": true
			},
		},
		height: 180,
		lineStyle: (obj: any) => {
			if (obj.type === "Keskiarvo") {
				return {
					lineDash: [4, 4],
					opacity: 1,
				};
			}
			return {
				opacity: 0.5,
			};
		},
		onReady: (plot: any) => {
			plot.chart.removeInteraction('legend-filter');
			plot.on('element:click', (args: any) => {
				console.log(args?.target?._INDEX);
			});
		},
	};
	return <Line {...config} />;
};

export default React.memo(CustomLineChart);

